require('normalize.css/normalize.css');
require('normalize.css/normalize.css');
require('./main.scss'); 
import css from './linux.scss'; 